import { BRAND } from "../lib/brand";

export const About = () => {
  return (
    <section id="about" data-testid="about-section" className="relative py-24 lg:py-32 bg-navy-800">
      <div className="mx-auto max-w-7xl px-6 md:px-12 grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
        <div className="relative">
          <div className="absolute -inset-3 border border-gold/30 translate-x-4 translate-y-4" />
          <img
            src="https://static.prod-images.emergentagent.com/jobs/04aafec5-89a2-40fb-8913-69408800e0f1/images/47c91336ecfec22f85eb606b4487bc7bb67162ce9330213a6b86256b7e962d82.png"
            alt="Business professional explaining strategy to a team"
            className="relative w-full h-[28rem] object-cover"
          />
        </div>

        <div>
          <p className="uppercase tracking-[0.2em] text-xs font-semibold text-gold mb-4">Who we are</p>
          <h2 className="font-display text-4xl sm:text-5xl tracking-tight leading-tight">
            A partner who sits on <span className="gold-text">your side</span> of the table
          </h2>
          <p className="mt-6 text-slate-300 leading-relaxed">
            At Six12 Consulting, we help businesses transform complexity into clarity. Whether you're
            evaluating contractual risk, intellectual property ownership, funding eligibility, or a
            high-stakes strategic decision, we bring structure to complexity and confidence to decision-making.
          </p>
          <p className="mt-4 text-slate-400 leading-relaxed">
            Like a prism separating light into its essential components, we analyze information, identify what
            matters most, and deliver actionable insight—built on <span className="text-gold">Strategy, Protection, Partnership, and Preparation</span>.
          </p>
        </div>
      </div>
    </section>
  );
};
